import { LoadableLazy } from '@confluence/loadable';

export { useSmartButtonConfigPanel } from './smart-buttons/edit/SmartButtonConfigPanel/useSmartButtonConfigPanel';
export { smartButtonExtensionProvider } from './smart-buttons/edit/SmartButtonManifest';
export { SmartButtonLoader } from './smart-buttons/view/SmartButtonLoader';
export { getRendererSmartButtonExtensionHandlers } from './smart-buttons/view/getRendererSmartButtonExtensionHandlers';
export { useSmartButtonPremiumGate } from './smart-buttons/useSmartButtonPremiumGate';

export const SmartButtonConfigPanel = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartButtonConfigPanel" */ './smart-buttons/edit/SmartButtonConfigPanel/SmartButtonConfigPanel'
			)
		).SmartButtonConfigPanel,
});
